module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/design-tile-images/design-tile-08-6901e60739f930dce25c2ecd086abfd4.jpg";